<script setup lang="ts">
import { SearchViewMode } from '#imports'

// const model = defineModel<SearchViewMode>('activeViewMode', { required: true })

const props = defineProps<{
  modelValue: SearchViewMode
}>()
const emit = defineEmits<{
  (e: 'update:modelValue', value: SearchViewMode): void
}>()

const activeViewMode = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const { t } = useI18n({
  useScope: 'local',
})

</script>

<template>
  <BaseButtonGroup>
    <BaseButtonAction
      v-for="viewMode in Object.values(SearchViewMode)"
      :key="viewMode"
      class="h-9 w-24"
      :color="activeViewMode === viewMode ? 'primary' : 'muted'"
      @click="activeViewMode = viewMode"
    >
      <span class="capitalize">
        {{ t(`viewMode.${viewMode}`) }}
      </span>
    </BaseButtonAction>
  </BaseButtonGroup>
</template>

<i18n lang="json">
{
  "en": {
    "viewMode": {
      "list": "List",
      "map": "Map"
    }
  },
  "nl": {
    "viewMode": {
      "list": "Lijst",
      "map": "Kaart"
    }
  }
}
</i18n>
